import { createContext, useContext } from 'react'

interface TeacherPreviewContextType {
  isTeacherPreview: boolean
}

const TeacherPreviewContext = createContext<TeacherPreviewContextType>({
  isTeacherPreview: false
})

export const useTeacherPreview = () => useContext(TeacherPreviewContext)

export const usePreviewPath = () => {
  const { isTeacherPreview } = useTeacherPreview()
  return (path: string) => isTeacherPreview ? `/teacher/preview${path}` : path
}

export default TeacherPreviewContext
